import React from 'react'
import Header from '../Components/Header/Header'
import Orders from '../Components/Orders/Orders'

function Order() {
  return (
    <div>
        <Header></Header>
        <Orders></Orders>
    </div>
  )
}

export default Order